import { render, staticRenderFns } from "./aiTester.vue?vue&type=template&id=72b720f4"
import script from "./aiTester.vue?vue&type=script&lang=js"
export * from "./aiTester.vue?vue&type=script&lang=js"
import style0 from "./aiTester.vue?vue&type=style&index=0&id=72b720f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports